module.exports = __webpack_public_path__ + "static/img/ETHAN-HERBERT.cda5b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ETHAN-HERBERT.jpg
// module id = AlqM
// module chunks = 0